import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Login from './login'
import Index from './components/index'
import IndexSealOut from './components/indexSealOut'
import App from './App'
import contract from './components/contract'
import sealOut from './components/sealOut'
import audit from './components/audit'
import auditSealOut from './components/auditSealOut'
import log from './components/log'
import logSealOut from './components/logSealOut'
import loginAuthen from './components/loginAuthen'

/* eslint-disable no-new */
// require('weui/dist/style/weui.min.css')

Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.http.options.root = '/chamber'
Vue.http.options.emulateHTTP = true
Vue.http.options.emulateJSON = true
const routes = [
  { path: '/', redirect: '/list/index' },
  { path: '/loginAuthen', component: loginAuthen },
  { path: '/login/:type/:wxid', component: Login },
  { path: '/list/:op', component: Index },
  { path: '/listSealOut/:op', component: IndexSealOut },
  { path: '/contract/:op/:contractId', component: contract },
  { path: '/sealOut/:op/:sealOutId', component: sealOut },
  { path: '/verifie/:contractId', component: audit },
  { path: '/auditSealOut/:sealOutId', component: auditSealOut },
  { path: '/log/:contractId', component: log },
  { path: '/logSealOut/:sealOutId', component: logSealOut },
  { path: '/login/operate', component: Login },
  { path: '/loginAuthen', component: loginAuthen }
]
const router = new VueRouter({
  routes
})
window.router = router

// router.beforeEach((to, from, next) => {
//   console.dir(from)
//   next()
// })

Vue.http.interceptors.push(function (req, next) {
  next(function (res) {
    if (res.status === 500) {
      window.alert('数据出错，请稍后再试')
      return
    }
    if (res.status === 404) {
      window.alert('没有找到页面')
      router.back()
      return
    }
    // console.dir(res)
    if (res.status === 401 || res.status === 403) {
      let contractUrl = window.location.href
      router.push({path: '/loginAuthen', query: { url: contractUrl }})
      // return
    }
  })
})

new Vue({
  router,
  render: h => h(App)
}).$mount('app')



// WEBPACK FOOTER //
// ./src/main.js